{
  "name": "locumsnest",
  "version": "v22.12.1",
  "license": "MIT",
  "scripts": {
    "snapshot-dev": "./.snapshot-dev",
    "ng": "nx",
    "nx": "nx",
    "setup:ca": "sudo cp ca.dev.locumsnest.co.uk /etc/pki/ca-trust/source/anchors/&& sudo update-ca-trust",
    "yarn": "ng config -g cli.packageManager yarn",
    "start": "node --max_old_space_size=8048 ./node_modules/.bin/nx serve --project=hospital-admin",
    "start:tools": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=tools",
    "start:debug-prod": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=debug-prod",
    "start:debug-qa": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=debug-qa",
    "start:debug-demo": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=debug-demo",
    "start:debug-dev": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=debug-dev",
    "start:debug-pre-prod": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=debug-pre-prod",
    "start:debug-lab": "node --max_old_space_size=8048 ./node_modules/.bin/nx run hospital-admin:serve --configuration=debug-lab",
    "build": "node --max_old_space_size=8048 ./node_modules/.bin/nx build",
    "build:prod:hospital-admin": "yarn build:prod",
    "build:dev": "node --max_old_space_size=8048 ./node_modules/.bin/nx build --project=hospital-admin --configuration=dev",
    "build:prod": "node --max_old_space_size=8048 ./node_modules/.bin/nx build --project=hospital-admin --configuration production",
    "build:qa:hospital-admin": "node --max_old_space_size=8048 ./node_modules/.bin/nx build --project=hospital-admin --configuration=qa",
    "deploy:preprod": "yarn build:prod && ./deploy pre-prod",
    "deploy:staging": "yarn build:prod && ./deploy staging",
    "deploy:migration": "yarn build:prod && ./deploy migration",
    "deploy:dev": "yarn build:dev && ./deploy dev",
    "test": "nx test",
    "lint": "./node_modules/.bin/nx workspace-lint && ng lint",
    "lint:changed": ". ./.scripts && lint_changed",
    "elect:nightly": ". ./.scripts && elect_nightly",
    "compile:changed": ". ./.scripts && compile_changed",
    "e2e": "ng e2e",
    "affected:apps": "nx affected:apps",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "nxformat": "nx format:write",
    "format": "prettier '**/*' --write --ignore-unknown",
    "format:changed": ". ./.scripts && format_changed",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate latest",
    "update:check": "nx update:check",
    "update:skip": "nx update:skip",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "workspace-generator": "nx workspace-generator",
    "release": ". ./.scripts && release_sentry ",
    "yarn:set:stable": "yarn set version 1.22.19"
  },
  "scarfSettings": {
    "enabled": false
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "19.2.6",
    "@angular/cdk": "19.2.9",
    "@angular/common": "19.2.6",
    "@angular/compiler": "19.2.6",
    "@angular/core": "19.2.6",
    "@angular/fire": "^19.1.0",
    "@angular/forms": "19.2.6",
    "@angular/localize": "19.2.6",
    "@angular/platform-browser": "19.2.6",
    "@angular/platform-browser-dynamic": "19.2.6",
    "@angular/router": "19.2.6",
    "@chamaeleonidae/chmln": "^1.0.1",
    "@ckeditor/ckeditor5-angular": "^10.0.0",
    "@maskito/angular": "^3.7.2",
    "@maskito/core": "^3.7.2",
    "@maskito/kit": "^3.7.2",
    "@ng-bootstrap/ng-bootstrap": "18.0.0",
    "@ng-select/ng-select": "14.7.0",
    "@ngneat/helipopper": "^10.2.0-alpha.2",
    "@ngneat/overview": "6.1.2",
    "@ngrx/effects": "19.1.0",
    "@ngrx/entity": "19.1.0",
    "@ngrx/operators": "19.1.0",
    "@ngrx/router-store": "19.1.0",
    "@ngrx/store": "19.1.0",
    "@ngrx/store-devtools": "19.1.0",
    "@ngxpert/hot-toast": "4.2.0",
    "@nx/angular": "20.8.1",
    "@nx/devkit": "20.8.1",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^9.14.0",
    "@swc/helpers": "0.5.15",
    "angular-file": "^4.0.2",
    "apexcharts": "^4.7.0",
    "awesome-phonenumber": "^7.4.0",
    "bootstrap": "^5.3.5",
    "calendar": "^0.1.1",
    "chroma-js": "^3.1.2",
    "ckeditor5": "^47.0.0",
    "core-js": "3.36.1",
    "file-saver": "^2.0.5",
    "immutable": "4.0.0-rc.12",
    "js-video-url-parser": "^0.5.1",
    "lodash-es": "^4.17.21",
    "moment-range": "^4.0.2",
    "moment-timezone": "^0.5.48",
    "ng-apexcharts": "^1.15.0",
    "ng-recaptcha": "13.2.1",
    "ngrx-forms": "^8.0.0",
    "ngx-cookie-service": "19.1.2",
    "ngx-infinite-scroll": "19.0.0",
    "ngx-nested-ellipsis": "3.0.1",
    "papaparse": "^5.5.2",
    "rxjs": "~7.8.2",
    "sass": "^1.86.3",
    "storybook": "^8.6.12",
    "tslib": "^2.7.0",
    "uuid": "^11.1.0",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.7",
    "@angular-devkit/core": "19.2.7",
    "@angular-devkit/schematics": "19.2.7",
    "@angular-eslint/eslint-plugin": "19.3.0",
    "@angular-eslint/eslint-plugin-template": "19.3.0",
    "@angular-eslint/template-parser": "19.3.0",
    "@angular/cli": "~19.2.0",
    "@angular/compiler-cli": "19.2.6",
    "@angular/language-service": "19.2.6",
    "@chromatic-com/storybook": "^3.2.6",
    "@eslint/eslintrc": "^2.1.1",
    "@eslint/js": "^9.8.0",
    "@ianvs/prettier-plugin-sort-imports": "^4.4.1",
    "@ngrx/eslint-plugin": "19.1.0",
    "@ngrx/schematics": "19.1.0",
    "@nx/eslint": "20.8.1",
    "@nx/eslint-plugin": "20.8.1",
    "@nx/jest": "20.8.1",
    "@nx/js": "20.8.1",
    "@nx/plugin": "20.8.1",
    "@nx/storybook": "20.8.1",
    "@nx/web": "20.8.1",
    "@nx/workspace": "20.8.1",
    "@schematics/angular": "19.2.7",
    "@sentry/cli": "^2.43.1",
    "@storybook/addon-essentials": "8.6.12",
    "@storybook/addon-interactions": "8.6.12",
    "@storybook/angular": "8.6.12",
    "@storybook/core-server": "8.6.12",
    "@storybook/test": "^8.6.12",
    "@storybook/test-runner": "0.22.0",
    "@swc-node/register": "1.9.2",
    "@swc/cli": "0.6.0",
    "@swc/core": "1.5.7",
    "@types/chroma-js": "^3.1.1",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "5.1.7",
    "@types/jasminewd2": "~2.0.13",
    "@types/jest": "29.5.14",
    "@types/lodash-es": "^4.17.12",
    "@types/node": "^18.16.9",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/utils": "^8.19.0",
    "angular-eslint": "19.3.0",
    "dotenv": "16.5.0",
    "eslint": "^9.8.0",
    "eslint-config-prettier": "10.1.2",
    "eslint-plugin-cypress": "^2.15.1",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "^48.0.6",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-unused-imports": "^4.1.4",
    "jasmine-core": "5.1.1",
    "jasmine-marbles": "^0.9.2",
    "jasmine-spec-reporter": "7.0.0",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-environment-node": "^29.7.0",
    "jest-preset-angular": "14.4.2",
    "jsonc-eslint-parser": "^2.1.0",
    "nx": "20.8.1",
    "postcss-svg": "^3.0.0",
    "prettier": "3.5.3",
    "prettier-plugin-organize-attributes": "^1.0.0",
    "ts-jest": "29.1.2",
    "ts-node": "10.9.2",
    "tsc-files": "^1.1.4",
    "typescript": "5.7.3",
    "typescript-eslint": "^8.19.0"
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
